module.exports = __webpack_public_path__ + "img/Group 553.6613e262.png";